module.exports = __webpack_public_path__ + "img/61.57b5d0f8.png";